import React, { useState } from 'react';
import { RadioButton, Table } from '@cambridgeassessment/cambridge-ui';
import { Entry } from '@cambridgeassessment/lib-ee-commons/src/domain/db';

import { sortLearners, TableSortConfig } from '../helpers';
import { StyledRadioBtn, TableWrapper } from '../ManageSampleChanges.styles';
import { baseTableCols } from '../baseTableCols';

interface Props {
  filteredLearnersList: Entry[];
  setLearnerIn: (learnerIn: Entry) => void;
  learnerIn: Entry | undefined;
  isPartOfConsortia: boolean;
  maxMark?: number;
}

export const LearnersReplacementTable = (props: Props): JSX.Element => {
  const { filteredLearnersList, learnerIn, setLearnerIn, isPartOfConsortia, maxMark } = props;
  const qaId = 'replacement';
  const [sortConfig, setSortConfig] = useState<TableSortConfig>();

  const filteredAndSortedList = [...filteredLearnersList];

  sortLearners(filteredAndSortedList, sortConfig);

  const renderRadioBtn = (item: Entry) => {
    const isChecked = item._id === learnerIn?._id;

    return (
      <StyledRadioBtn>
        <RadioButton
          dataQaId={`radio-${item.learner.number}`}
          onChange={() => {
            setLearnerIn(item);
          }}
          checked={isChecked}
        />
      </StyledRadioBtn>
    );
  };

  return (
    <TableWrapper>
      <Table<Entry>
        data={filteredAndSortedList}
        noItemsErrorBody={<div data-qa-id={`no-candidates-${qaId}`}>No candidates found</div>}
        onRowClick={(item) => {
          setLearnerIn(item);
        }}
        columns={[
          {
            renderCell: function render(item) {
              return renderRadioBtn(item);
            },
            align: 'left',
          },
          ...baseTableCols(sortConfig, setSortConfig, isPartOfConsortia, maxMark, qaId),
        ]}
      />
    </TableWrapper>
  );
};
